import {useQuery} from "@tanstack/react-query"
import {useMemo} from "react"
import {generalSettingsService} from "services"
import {GeneralSettingField} from "types/settings/general-setting"

type UseGeofencingSettingsProps = {
    enabled?: boolean
}

const useGeofencingSettings = ({enabled = true}: UseGeofencingSettingsProps = {}) => {
    const {data, refetch, isFetching} = useQuery(
        ["geofencing-setting"],
        () => generalSettingsService.getSettings([GeneralSettingField.GeofencingRadiusInMeters]),
        {
            initialData: [],
            enabled
        }
    )

    const geofencingRadiusInMeters = useMemo(
        () => data.find((setting) => setting.field === GeneralSettingField.GeofencingRadiusInMeters)?.value as string,
        [data]
    )

    return {
        data,
        geofencingRadiusInMeters,
        refetch,
        isFetching
    }
}

export {useGeofencingSettings}
